import { findAppByKey, type InstallableApp } from "~/pwa/installableApps";
import shortcutModuleOrder from "~/pwa/shortcutModules";

interface LaunchModuleInput {
	enabledByKey: Partial<Record<string, boolean>>;
	lastModuleKey: string | null;
}

const isUsable = (app: InstallableApp | null, enabledByKey: Partial<Record<string, boolean>>): app is InstallableApp =>
	app !== null && enabledByKey[app.key] === true;

const resolveLaunchModule = ({ enabledByKey, lastModuleKey }: LaunchModuleInput): InstallableApp | null => {
	const lastModule = findAppByKey(lastModuleKey);
	if (isUsable(lastModule, enabledByKey)) return lastModule;

	for (const key of shortcutModuleOrder) {
		const candidate = findAppByKey(key);
		if (isUsable(candidate, enabledByKey)) return candidate;
	}
	return null;
};

export type { LaunchModuleInput };
export default resolveLaunchModule;
